import Icon from "@ch/components/Icons/Icon";
import { TooltipButton } from "@ch/components/tooltip";
import type { FC } from "react";

interface ISingleHistoryMetricCardProps {
  data?: Record<string, string>;
  labels: Record<string, string>;
  onEdit?: () => void;
  onDelete?: () => void;
  onPrint?: (acton?: string) => void;
  onViewAttachment?: () => void;
}

const SingleHistoryMetricCard: FC<ISingleHistoryMetricCardProps> = ({
  data,
  labels,
  onEdit,
  onDelete,
  onPrint,
  onViewAttachment,
}) => {
  return (
    <div className="min-w-[206px] divide-y rounded-xl border p-4 pt-2">
      <div className="flex w-full items-center justify-between">
        <span className="w-max text-xs text-green">{data?.type ?? ""}</span>
        <div className="flex h-full items-center gap-3">
          {onViewAttachment && (
            <TooltipButton
              label="View attachment"
              onClick={() => onViewAttachment()}
            >
              <Icon name="paper-clip" size={16} />
            </TooltipButton>
          )}
          {onPrint && (
            <>
              <TooltipButton label="View" onClick={() => onPrint?.("view")}>
                <Icon name="eye-open" size={16} />
              </TooltipButton>
              <TooltipButton label="Print" onClick={() => onPrint?.()}>
                <Icon name="download" size={16} />
              </TooltipButton>
            </>
          )}
          <TooltipButton label="Edit" onClick={() => onEdit?.()}>
            <div className="mb-1">
              <Icon name="eye-open" size={16} />
            </div>
            <div className="absolute left-[15px] top-[12px]">
              <Icon name="edit" size={16} />
            </div>
          </TooltipButton>
          <TooltipButton label="Delete" onClick={() => onDelete?.()}>
            <Icon name="delete" size={16} />
          </TooltipButton>
        </div>
      </div>
      {Object.entries(labels).map(([key, label]) => (
        <div
          className="flex h-14 items-center justify-between gap-4 p-2 px-3"
          key={key}
        >
          <p className="w-5/12 font-semibold">{label}</p>
          <div
            className="tooltip tooltip-top flex w-7/12 justify-end"
            data-tip={data?.[key]}
          >
            <p className="truncate text-sm text-gray">
              <span className="text-end">{data?.[key]}</span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SingleHistoryMetricCard;
